import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({ name: 'timeZone' })
export class TimeZonePipe implements PipeTransform {
  transform(dateValue: Date | string, tz: string = 'America/Denver', format: string = 'ZZZZ'): string {
    const jsDate = new Date(dateValue);
    return DateTime.fromJSDate(jsDate).setZone(tz).toFormat(format);
  }
}
